module.exports = __webpack_public_path__ + "img/geminitay-e5f31b21-f5b1-4e40-ce6f-08d958505b99.png";